import uathttpClient from '../utils/httpClient';

export const getSchemePriceChart = async (
  schcode: string,
  duration: string,
  timeframe: string,
) => {
  return uathttpClient.get(
    `/api/v1/schemes/navhistory/${schcode}/${duration}/${timeframe}`,
  );
};
